import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonContactRequestGridPart } from '../../../../../ui/widget';
import { DeliveryEngagementsService } from '../../delivery-engagements.service';

@Component({
	selector: 'delivery-contact-request-view-part',
	standalone: true,
	imports: [CommonContactRequestGridPart],
	templateUrl: './contact-request-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./contact-request-view.part.scss'],
})
export class DeliveryContactReqFollowUpsViewPart {
	public readonly pageService = inject(DeliveryEngagementsService);
	public contactRequests = computed(() => (this.pageService.contactRequests() || []));
}